import { http, camelify } from '../rest';

export function loginAs(http, camelify) {
  return {
    async execute(userId) {
      const response = await http.get(`/salesforce/login_as/${userId}`);
      const data = response.data;
      return camelify(data);
    },
  };
}

export default loginAs(http, camelify);
